(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('TriggerService', TriggerService);

  TriggerService.$inject = ['$resource'];

	 function TriggerService ($resource) {
    return $resource(apiUrl + '/channels/:op/:type/:id', { op: '@op', type: '@type', id: '@id' }, {
      get: { method: 'GET', params: {}, isArray: false },
      saveOthers: { method: 'POST', params: {}, isArray: false }
    });
  }
})();
